import { HttpErrorType } from './enums';
import { HttpRequest } from './http-request';

export class HttpRequestError {
    status: number;
    message: string;
    type: HttpErrorType;
    request: HttpRequest;
}
